import { Tag } from 'antd';
import React from 'react';

import type { ISubscription } from '@common/types';

export const FeatureAssignments: React.FC<{
  subscription: ISubscription;
}> = ({ subscription }) => {
  const count = subscription?.assignedFeatures?.length || 0;

  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <Tag color={count > 0 ? 'blue' : 'default'}>{count}</Tag>
    </div>
  );
};
